import { render } from "./enterpriseChannel.vue?vue&type=template&id=4e0165d0"
import script from "./enterpriseChannel.vue?vue&type=script&lang=js"
export * from "./enterpriseChannel.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/enterPriseConfig/enterpriseChannel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e0165d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e0165d0', __exports__)) {
    console.log('reload')
    api.reload('4e0165d0', __exports__)
  }
  
  module.hot.accept("./enterpriseChannel.vue?vue&type=template&id=4e0165d0", () => {
    console.log('re-render')
    api.rerender('4e0165d0', render)
  })

}


export default __exports__